import { generateSignedUrl } from "../generateSignedUrl";
import { SocketEvents } from "./SocketEvents";

let sockets = [];

export const initSocketLive = (id, store) => {
    let socket;

    const connectWebSocket = async () => {
        let wsUrl = window.process.env.WS_LIVE_URL;

        if (!wsUrl?.includes("wss://")) {
            wsUrl = "wss:" + wsUrl;
        }
        wsUrl += "/?room=" + id;
        wsUrl += "&role=participant";
        const signedWsUrl = await generateSignedUrl(new URL(wsUrl));

        socket = new WebSocket(signedWsUrl);
        let rejoined = false;
        const startTime = Date.now();

        const rejoin = async () => {
            if (!rejoined) {
                rejoined = true;
                let timeSinceLastJoin = Date.now() - startTime;
                if (timeSinceLastJoin < 1000) {
                    await new Promise((resolve) =>
                        setTimeout(resolve, 1000 - timeSinceLastJoin)
                    );
                }
                connectWebSocket(); // Reconnect
            }
        };

        socket.onopen = () => {
            sockets.push(id);
        };

        socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            switch (data.type) {
                case SocketEvents.liveStarted:
                    store.commit("updateLiveStatus", {
                        id: id,
                        status: 0,
                    });
                    break;
                case SocketEvents.liveEnded:
                    store.commit("updateLiveStatus", {
                        id: id,
                        status: 1,
                    });
                    break;
            }
        };

        socket.onerror = (error) => {
            console.error("Error in socket connection:", error);
            socket.close();
            rejoin();
        };

        socket.onclose = () => {
            rejoin();
        };

        store.commit("setSocket", socket);
    };

    if (!sockets.includes(id)) {
        connectWebSocket();
    }

    return () => {
        if (socket) {
            socket.close();
        }
    };
};


